import React from 'react';
import { Alert, AlertIcon, AlertTitle, AlertDescription, Box } from '@chakra-ui/react';
import { usePermissions } from './PermissionGuard';

const ReadOnlyBanner: React.FC = () => {
  const { isViewer } = usePermissions();

  if (!isViewer) {
    return null;
  }

  return (
    <Alert status="info" borderRadius="xl" mb={6} boxShadow="sm">
      <AlertIcon />
      <Box>
        <AlertTitle fontSize="sm">Read-only access</AlertTitle>
        <AlertDescription fontSize="sm">
          Your account has viewer permissions. You can browse data but cannot create, edit, or delete anything.
        </AlertDescription>
      </Box>
    </Alert>
  );
};

export default ReadOnlyBanner;
